import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ExtraCameraImage, ImageBrowserState } from './image-browser.reducer';
import dayjs from 'dayjs';

export const imageBrowserSelector = createFeatureSelector<ImageBrowserState>('imageBrowser');

export const selectCurrentFrame = createSelector(imageBrowserSelector, state => ({
  ...state.timeline[state.currentFrame],
  loaded: state.currentFrameLoaded,
  middleIndex: (state.loopStartIndex + state.loopEndIndex) / 2,
}));

export const selectCurrentFrameLoaded = createSelector(imageBrowserSelector, state => state.currentFrameLoaded);

export const selectIsPlaying = createSelector(imageBrowserSelector, state => state.playing);

/** Set when a jump was given up on: the camera has no frames reaching that moment. */
export const selectJumpUnreachable = createSelector(imageBrowserSelector, state => state.jumpUnreachable);
export const selectIsLooping = createSelector(imageBrowserSelector, state => state.looping);
export const selectIsLoadingInital = createSelector(imageBrowserSelector, state => state.loadingInitial);

/**
 * Whether the browser is still fetching frames. A jump to the paired event opens on the two images
 * the event carries and pages the rest in behind it, so the button stays busy for a moment after
 * the picture has changed.
 */
export const selectIsLoadingImages = createSelector(
  imageBrowserSelector,
  state => state.loadingInitial || state.loadingBefore || state.loadingAfter,
);

export const selectCurrentTime = createSelector(selectCurrentFrame, frame => dayjs(frame.date).format('hh:mm:ss a'));

export const selectFilterRegion = createSelector(imageBrowserSelector, state => state.cameraFilterRegion);

export const selectCamerasToLoad = createSelector(imageBrowserSelector, state =>
  Object.keys(state.extraCamerasTimeline)
    .map(x => parseInt(x))
    .filter(cameraId => cameraId !== state.cameraId)
    .filter(cameraId => !state.extraCamerasLoading[cameraId])
    .filter(cameraId => !state.extraCamerasTimeline[cameraId].some(img => img.index === state.currentFrame)),
);
export const selectExtraCameras = createSelector(imageBrowserSelector, state =>
  state.extraCamerasIds.map(camId =>
    state.extraCamerasLoading[camId]
      ? ({ url: 'https://placehold.co/1066x600?text=LOADING', id: camId } as ExtraCameraImage)
      : state.extraCamerasTimeline[camId] &&
          state.extraCamerasTimeline[camId].length > 0 &&
          state.extraCamerasTimeline[camId].findIndex(x => x.index === state.currentFrame) !== -1
        ? state.extraCamerasTimeline[camId].find(x => x.index === state.currentFrame)
        : ({ url: 'https://placehold.co/1066x600?text=NO+MOTION+DETECTED', id: camId } as ExtraCameraImage),
  ),
);
